import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=51099158&scoped=true"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&id=51099158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51099158",
  null
  
)

export default component.exports